import BOSS_UNAVAILABLE_CONSTANTS from './BossUnavailable.constants';

export const moveItemsToBossUnavailableList = (payload) => {
  return {
    type: BOSS_UNAVAILABLE_CONSTANTS.MOVE_BOSS_UNAVAILABLE_ITEMS,
    payload,
  };
};

export const setBossUnavailableList = (payload) => {
  return {
    type: BOSS_UNAVAILABLE_CONSTANTS.SET_BOSS_UNAVAILABLE_PRODUCTS,
    payload,
  };
};

export const getBossUnavailableList = (payload) => {
  return {
    type: BOSS_UNAVAILABLE_CONSTANTS.FETCH_BOSS_UNAVAILABLE_ITEMS,
    payload,
  };
};

export const setBossUnavailableListID = (payload) => {
  return {
    type: BOSS_UNAVAILABLE_CONSTANTS.SET_BOSS_UNAVAILABLE_LIST_ID,
    payload,
  };
};

export const removeItemsToBossUnavailableList = (payload) => {
  return {
    type: BOSS_UNAVAILABLE_CONSTANTS.REMOVE_BOSS_UNAVAILABLE_ITEM,
    payload,
  };
};

export const fetchConvertedBossUnavailableList = (payload) => {
  return {
    type: BOSS_UNAVAILABLE_CONSTANTS.FETCH_CONVERTED_BOSS_UNAVAILABLE_ITEM,
    payload,
  };
};

export const setConvertedBossUnavailableList = (payload) => {
  return {
    type: BOSS_UNAVAILABLE_CONSTANTS.SET_CONVERTED_BOSS_UNAVAILABLE_ITEM,
    payload,
  };
};

export const setRemovedItemsBossUnavailableList = (payload) => {
  return {
    type: BOSS_UNAVAILABLE_CONSTANTS.SET_REMOVED_BOSS_UNAVAILABLE_ITEM,
    payload,
  };
};

export const resetBossUnavailableState = () => {
  return {
    type: BOSS_UNAVAILABLE_CONSTANTS.RESET_BOSS_UNAVAILABLE_STATE_REDUCER,
  };
};
export const removeDeletedItem = (payload) => {
  return {
    type: BOSS_UNAVAILABLE_CONSTANTS.REMOVE_DELETED_ITEM,
    payload,
  };
};

export const addDeletedItemOnAPiFailure = () => {
  return {
    type: BOSS_UNAVAILABLE_CONSTANTS.ADD_DELETED_ITEM_ON_API_FAILURE,
  };
};

export const setBossUnavailableProductInList = (payload) => {
  return {
    type: BOSS_UNAVAILABLE_CONSTANTS.SET_BOSS_UNAVAILABLE_PRODUCTS_IN_LIST,
    payload,
  };
};
